import { memo } from 'react';
import { ForceUpdateForm } from './components/ForceUpdateForm';
import { MinimalCard } from 'components/styled';

const ForceUpdateCard = () => {
  return (
    <MinimalCard sx={{ height: '100%' }}>
      <ForceUpdateForm />
    </MinimalCard>
  );
};

export default memo(ForceUpdateCard);
